import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTES } from '../common/constants/routes.constant';
import { CURRENT_STATUS } from '../common/constants/status.constant';

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  #router = inject(Router);
  constructor() {}

  goToHome(): void {
    this.#router.navigate([`./${ROUTES.WORKFLOW}`]);
  }

  goToDiagnosiComplete(sessionId: string): void {
    if (sessionId)
      this.#router.navigate([`./${ROUTES.DIAGNOSIS_COMPLETE}`, sessionId]);
  }

  goToSolutionSelection(sessionId: string): void {
    if (sessionId) {
      this.#router.navigate([`./${ROUTES.WORKFLOW}`, sessionId]);
    }
  }

  goByStatus(sessionId: string, status: string): void {
    switch (status) {
      case CURRENT_STATUS.IN_PROGRESS:
        this.goToSolutionSelection(sessionId);
        break;
      case CURRENT_STATUS.DIAGNOSIS_COMPLETED:
      case CURRENT_STATUS.SOLUTION_SELECTED:
      case CURRENT_STATUS.APPROVED_FOR_DESIGN:
        this.goToDiagnosiComplete(sessionId);
        break;
    }
  }
}
